var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',{attrs:{"id":"editor","editorToolbar":_vm.customToolbar},model:{value:(_vm.editor),callback:function ($$v) {_vm.editor=$$v},expression:"editor"}})}
var staticRenderFns = []

export { render, staticRenderFns }